export default "__VITE_ASSET__BCVmXVLJ__"